module.exports = __webpack_public_path__ + "static/media/LinkedInIcon.1dbff803.svg";